import { CircularProgress, IconButton, Tooltip, Icons } from '@healthinal/ui';
import { MouseEvent } from 'react';

interface SyncListActionProps {
    onClick: () => void;
    loading?: boolean;
    disabled?: boolean;
    title?: string;
}

export function SyncListAction({
    onClick,
    loading = false,
    disabled = false,
    title = 'Synchronisieren',
}: SyncListActionProps) {
    const handleMouseDown = (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        e.stopPropagation();
        onClick();
    };

    return (
        <Tooltip title={title}>
            <span>
                <IconButton
                    size="sm"
                    variant="outlined"
                    color="neutral"
                    disabled={disabled || loading}
                    onMouseDown={handleMouseDown}
                    onClick={handleClick}
                >
                    {loading ? <CircularProgress size="sm" /> : <Icons.Sync />}
                </IconButton>
            </span>
        </Tooltip>
    );
}